var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#515864"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 5.2v5.6h5.6c.656 0 1.2.544 1.2 1.2 0 .656-.544 1.2-1.2 1.2h-5.6v5.6c0 .656-.544 1.2-1.2 1.2-.656 0-1.2-.544-1.2-1.2v-5.6H5.2c-.656 0-1.2-.544-1.2-1.2 0-.656.544-1.2 1.2-1.2h5.6V5.2c0-.656.544-1.2 1.2-1.2.656 0 1.2.544 1.2 1.2z"
  })));
}
export default SvgPlusLink;